<template>
  <div class="sidebar">
    <!-- Logo区域 -->
    <div class="sidebar-header">
      <div class="logo">
        <div class="logo-icon">
          <el-icon size="28" color="#fff"><Money /></el-icon>
        </div>
        <span class="logo-text">代付系统</span>
      </div>
    </div>

    <!-- 菜单区域 -->
    <div class="sidebar-menu">
      <el-menu
        :default-active="$route.path"
        :router="true"
        class="sidebar-menu-list"
        background-color="transparent"
        text-color="#e1e5e9"
        active-text-color="#409eff"
      >
        <el-menu-item index="/" class="menu-item">
          <el-icon><House /></el-icon>
          <span>退款管理</span>
        </el-menu-item>

        <el-sub-menu index="/user" class="submenu">
          <template #title>
            <el-icon><User /></el-icon>
            <span>用户管理</span>
          </template>
          <el-menu-item index="/user/list" class="submenu-item">用户列表</el-menu-item>
        </el-sub-menu>
        <!-- <el-sub-menu index="/shop" class="submenu">
          <template #title>
            <el-icon><Shop /></el-icon>
            <span>门店管理</span>
          </template>
          <el-menu-item index="/shop/list" class="submenu-item">门店列表</el-menu-item>
        </el-sub-menu> -->
        <el-sub-menu index="/payment" class="submenu">
          <template #title>
            <el-icon><Money /></el-icon>
            <span>支付管理</span>
          </template>
          <el-menu-item index="/payment/list" class="submenu-item">产品列表</el-menu-item>
          <el-menu-item index="/payment/setting" class="submenu-item">支付设置</el-menu-item>
        </el-sub-menu>
        <el-menu-item index="/about" class="menu-item">
          <el-icon><InfoFilled /></el-icon>
          <span>充值记录</span>
        </el-menu-item>
        <el-menu-item index="/task/list" class="menu-item">
          <el-icon><Document /></el-icon>
          <span>任务记录</span>
        </el-menu-item>
        <el-menu-item index="/daily/list" class="menu-item">
          <el-icon><Document /></el-icon>
          <span>每日统计</span>
        </el-menu-item>
      </el-menu>
    </div>

    <!-- 用户信息区域 -->
    <div class="sidebar-footer">
      <el-dropdown @command="handleCommand" trigger="click">
        <div class="user-info">
          <div class="user-avatar">
            <el-avatar size="32" src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png" />
          </div>
          <div class="user-details">
            <span class="username">{{ username }}</span>
            <span class="user-role">管理员</span>
          </div>
          <el-icon class="dropdown-icon"><ArrowDown /></el-icon>
        </div>
        <template #dropdown>
          <el-dropdown-menu class="user-dropdown">
            <el-dropdown-item command="settings">
              <el-icon><Setting /></el-icon>
              个人设置
            </el-dropdown-item>
            <el-dropdown-item command="logout" divided>
              <el-icon><SwitchButton /></el-icon>
              退出登录
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import { House, User, Money, ArrowDown, Setting, SwitchButton,InfoFilled } from '@element-plus/icons-vue'
import { getUsername, clearAuth } from '@/utils/auth'

export default {
  name: 'SidebarComponent',
  components: {
    House,
    User,
   
    Money,
    ArrowDown,
    Setting,
    SwitchButton,
    InfoFilled
    // Shop
  },
  setup() {
    const router = useRouter()
    const username = ref('管理员')

    onMounted(() => {
      username.value = getUsername()
    })

    const handleCommand = (command) => {
      switch (command) {
        case 'settings':
          ElMessage.info('个人设置功能开发中...')
          break
        case 'logout':
          handleLogout()
          break
      }
    }

    const handleLogout = () => {
      ElMessageBox.confirm(
        '确定要退出登录吗？',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).then(() => {
        clearAuth()
        ElMessage.success('已退出登录')
        router.push('/login')
      }).catch(() => {
        // 用户取消
      })
    }

    return {
      username,
      handleCommand
    }
  }
}
</script>

<style scoped>
.sidebar {
  width: 260px;
  height: 100vh;
  background: linear-gradient(180deg, #2c3e50 0%, #34495e 50%, #2c3e50 100%);
  display: flex;
  flex-direction: column;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  box-shadow: 4px 0 20px rgba(0, 0, 0, 0.1);
  border-right: 1px solid rgba(255, 255, 255, 0.1);
}

.sidebar-header {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
}

.logo {
  display: flex;
  align-items: center;
  color: #fff;
}

.logo-icon {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  padding: 8px;
  margin-right: 12px;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
}

.logo-text {
  font-size: 20px;
  font-weight: 600;
  background: linear-gradient(135deg, #fff 0%, #e1e5e9 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.sidebar-menu {
  flex: 1;
  overflow-y: auto;
  padding: 20px 0;
}

.sidebar-menu-list {
  border: none;
  background: transparent;
}

.menu-item,
.submenu-item {
  margin: 4px 16px;
  border-radius: 12px;
  height: 50px;
  line-height: 50px;
  transition: all 0.3s ease;
}

.menu-item.is-active,
.submenu-item.is-active {
  background: linear-gradient(135deg, #409eff 0%, #36a3f7 100%) !important;
  box-shadow: 0 4px 15px rgba(64, 158, 255, 0.4);
  transform: translateX(8px);
  color: #fff !important;
  font-weight: 600;
}

.submenu .el-sub-menu__title.is-active {
  background: rgba(64, 158, 255, 0.15) !important;
  color: #409eff !important;
  font-weight: 600;
}

/* 确保子菜单项在激活时有足够的对比度 */
.submenu-item.is-active {
  background: linear-gradient(135deg, #409eff 0%, #36a3f7 100%) !important;
  color: #fff !important;
  font-weight: 600;
}

/* 悬停状态增强 */
.menu-item:hover,
.submenu-item:hover {
  background: rgba(255, 255, 255, 0.15) !important;
  transform: translateX(8px);
  color: #fff !important;
}

.submenu .el-sub-menu__title:hover {
  background: rgba(255, 255, 255, 0.15) !important;
  color: #fff !important;
}

.submenu {
  margin: 4px 16px;
}

.submenu .el-sub-menu__title {
  border-radius: 12px;
  height: 50px;
  line-height: 50px;
  transition: all 0.3s ease;
}

.submenu .el-sub-menu__title:hover {
  background: rgba(255, 255, 255, 0.1) !important;
}

.submenu-item {
  margin-left: 32px !important;
  margin-right: 16px !important;
}

.sidebar-footer {
  height: 80px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
}

.user-info {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 12px 16px;
  border-radius: 16px;
  transition: all 0.3s ease;
  color: #e1e5e9;
  width: 100%;
  justify-content: flex-start;
  gap: 12px;
}

.user-info:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: translateY(-2px);
}

.user-avatar {
  flex-shrink: 0;
}

.user-details {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}

.username {
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  margin-bottom: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-role {
  font-size: 12px;
  color: #bdc3c7;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dropdown-icon {
  color: #bdc3c7;
  transition: transform 0.3s ease;
  flex-shrink: 0;
  margin-left: auto;
}

.user-info:hover .dropdown-icon {
  transform: rotate(180deg);
}

/* 滚动条样式 */
.sidebar-menu::-webkit-scrollbar {
  width: 6px;
}

.sidebar-menu::-webkit-scrollbar-track {
  background: transparent;
}

.sidebar-menu::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.sidebar-menu::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.3);
}

/* 用户下拉菜单样式 */
:deep(.user-dropdown) {
  border-radius: 12px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

:deep(.user-dropdown .el-dropdown-menu__item) {
  display: flex;
  align-items: center;
  padding: 12px 20px;
}

:deep(.user-dropdown .el-dropdown-menu__item .el-icon) {
  margin-right: 8px;
}

/* 确保Element Plus菜单组件的样式正确应用 */
:deep(.el-menu-item.is-active) {
  background: linear-gradient(135deg, #409eff 0%, #36a3f7 100%) !important;
  color: #fff !important;
  font-weight: 600;
}

:deep(.el-sub-menu__title.is-active) {
  background: rgba(64, 158, 255, 0.15) !important;
  color: #409eff !important;
  font-weight: 600;
}

:deep(.el-menu-item:hover) {
  background: rgba(255, 255, 255, 0.15) !important;
  color: #fff !important;
}

:deep(.el-sub-menu__title:hover) {
  background: rgba(255, 255, 255, 0.15) !important;
  color: #fff !important;
}
</style>
